import { useState } from "react";
import { Loader2, Minimize2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export const FitOnePage = ({ api, data, pages, onApply }) => {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    const before = data;
    try {
      const { data: r } = await api.post("/ai/fit-one-page", { resume: data, pages });
      onApply(r.resume);
      toast.success("Tightened to fit one page", {
        description: "Check the preview. If it's still over, remove an older role or try again.",
        action: { label: "Undo", onClick: () => onApply(before) },
        duration: 10000,
      });
    } catch (e) { toast.error(errMsg(e, "Couldn't shorten the resume")); }
    finally { setBusy(false); }
  };

  return (
    <button className="btn-thread mx-auto mt-3 !py-2 !text-sm" onClick={run} disabled={busy} data-testid="fit-one-page-btn">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Minimize2 className="h-4 w-4" />}
      {busy ? "Tightening your wording…" : "Fit to one page with AI"}
    </button>
  );
};
